import { Pipe, PipeTransform } from '@angular/core';
import {PlayerPositionDBChoices, PlayerPositionUIChoices} from '../../../features/profile/enums/player-position.enum';

@Pipe({
  name: 'playerPosition'
})
export class PlayerPositionPipe implements PipeTransform {

  transform(value: string): unknown {
    switch (value) {
      case PlayerPositionDBChoices.goalKeeper:
        return PlayerPositionUIChoices.goalKeeper;
      case PlayerPositionDBChoices.fullBack:
        return PlayerPositionUIChoices.fullBack;
      case PlayerPositionDBChoices.centreBack:
        return PlayerPositionUIChoices.centreBack;
      case PlayerPositionDBChoices.sweeper:
        return PlayerPositionUIChoices.sweeper;
      case PlayerPositionDBChoices.defensiveMidfielder:
        return PlayerPositionUIChoices.defensiveMidfielder;
      case PlayerPositionDBChoices.centralMidfielder:
        return PlayerPositionUIChoices.centralMidfielder;
      case PlayerPositionDBChoices.attackingMidfielder:
        return PlayerPositionUIChoices.attackingMidfielder;
      case PlayerPositionDBChoices.striker:
        return PlayerPositionUIChoices.striker;
      default:
        return 'Not Specified';
    }
  }
}


